<template>
    <div>
        <div class="filter-block">
            <div class="filter-block-left">
                <i class="fa fa-filter" style="margin-right: 10px;"></i>
                <el-input
                    v-model="filter.keyword"
                    @input="oninput"
                    size="mini"
                    placeholder="请输入搜索关键词或备注"
                    style="width: 200px;margin-right: 5px;"
                    clearable
                ></el-input>
                <el-tooltip class="item" effect="dark" placement="right-end">
                    <div slot="content">
                        搜索包含您在此处输入的单词的关键字短语。<br />
                        <!-- 也可以通过添加在一个你想漏掉的词前面。<br/>
                        例如，iphone-case 将显示包含单词<br/>
                        “iphone”的所有关键字短语，<br/>
                        但不包括任何包含单词“case”的关键字短语。 -->
                    </div>
                    <i
                        class="far fa-question-circle refine-search-info"
                        style="color: #fff;margin-right: 5px;"
                    ></i>
                </el-tooltip>
                <el-popover
                    class="button-star"
                    placement="bottom-start"
                    title
                    :popper-append-to-body="false"
                    :append-to-body="false"
                    popper-class="select-popper"
                    trigger="click"
                >
                    <div style="width: 150px;">
                        <el-checkbox-group
                            v-model="checkList"
                            @change="groupChange"
                        >
                            <div
                                class="checkbox-div"
                                v-for="(item, i) in this.$store.state.admin
                                    .star_arr"
                                :key="i"
                            >
                                <el-checkbox :label="item">
                                    <i
                                        class="el-icon-star-on icon-star"
                                        style="font-size: 20px;"
                                        :style="{ color: item.color }"
                                    ></i>
                                    <span
                                        style="width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                                        >{{ item.remark }}</span
                                    >
                                </el-checkbox>
                            </div>
                        </el-checkbox-group>
                        <div
                            v-if="checkList.length != 0"
                            @click="onEmpty()"
                            class="empty"
                        >
                            清空
                        </div>
                    </div>
                    <div slot="reference">
                        <el-button size="mini">
                            <i
                                v-if="checkList.length == 0"
                                class="el-icon-star-on"
                                style="color: #6a6c6f !important;font-size: 18px;"
                            ></i>
                            <span v-else>
                                <span
                                    v-for="(checkListItem, index) in checkList"
                                    :key="index"
                                >
                                    <i
                                        class="el-icon-star-on"
                                        style="font-size: 18px;"
                                        :style="{ color: checkListItem.color }"
                                    ></i>
                                </span>
                            </span>
                            <i
                                class="el-icon-caret-bottom caret-bottom"
                                style="color: #6a6c6f !important;font-size: 14px;"
                            ></i>
                        </el-button>
                    </div>
                </el-popover>
                <!-- <el-dropdown
                    @visible-change="clickFolders"
                    trigger="click"
                    placement="bottom">
                    <div class="el-dropdown-link" style="margin: 0 10px;">
                        <div class="button-plus">
                            <i class="el-icon-plus" style="font-size: 14px;color: #6a6c6f !important;"></i>
                            将关键词添加到文件夹
                        </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <div v-loading="loadingFolders" style="width: 200px;">
                            <div class="dropdown-header">
                                <span>添加到文件夹：</span>
                            </div>
                            <div style="margin: 0 10px 5px;">
                                <el-input size="small" v-model="nameFolders" @input="inputFolders" style="width: 180px;" placeholder="输入文件夹名称" clearable></el-input>
                            </div>
                            <div class="dropdown-header">
                                <span class="dropdown-header__title">文件夹</span>
                                <span class="dropdown-header__title">关键词</span>
                            </div>
                            <div v-if="nameFolders.length == 0" class="dropdown-items">
                                <div v-for="(item, i) in this.arrFolders" :key="i" class="dropdown-item" @click="keywordFolders(item)">
                                    <span>{{item.name}}</span>
                                    <span>{{item.kw_count}}</span>
                                </div>
                            </div>
                            <div v-if="nameFolders.length != 0" class="dropdown-items">
                                <div v-for="(item, i) in this.arrFolders_search" :key="i" class="dropdown-item" @click="keywordFolders(item)">
                                    <span>{{item.name}}</span>
                                    <span>{{item.kw_count}}</span>
                                </div>
                            </div>
                            <el-divider></el-divider>
                            <div @click="addFolders()" class="folder">创建文件夹</div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown> -->
                <el-popover
                    @show="clickFolders"
                    :popper-append-to-body="false"
                    :append-to-body="false"
                    class="button-star"
                    placement="bottom-start"
                    title
                    popper-class="select-popper"
                    trigger="click"
                >
                    <div v-loading="loadingFolders" style="width: 200px;">
                        <div class="dropdown-header">
                            <span>添加到文件夹：</span>
                        </div>
                        <div style="margin: 0 10px 5px;">
                            <el-input
                                size="small"
                                v-model="nameFolders"
                                @input="inputFolders"
                                style="width: 180px;"
                                placeholder="输入文件夹名称"
                                clearable
                            ></el-input>
                        </div>
                        <div class="dropdown-header">
                            <span class="dropdown-header__title">文件夹</span>
                            <span class="dropdown-header__title">关键词</span>
                        </div>
                        <div
                            v-if="nameFolders.length == 0"
                            class="dropdown-items"
                        >
                            <div
                                v-for="(item, i) in this.arrFolders"
                                :key="i"
                                class="dropdown-item"
                                @click="keywordFolders(item)"
                            >
                                <div class="dropdown-item-txt">
                                    {{ item.name }}
                                </div>
                                <span>{{ item.kw_count }}</span>
                            </div>
                        </div>
                        <div
                            v-if="nameFolders.length != 0"
                            class="dropdown-items"
                        >
                            <div
                                v-for="(item, i) in this.arrFolders_search"
                                :key="i"
                                class="dropdown-item"
                                @click="keywordFolders(item)"
                            >
                                <span>{{ item.name }}</span>
                                <span>{{ item.kw_count }}</span>
                            </div>
                        </div>
                        <el-divider></el-divider>
                        <div @click="addFolders()" class="folder">
                            创建文件夹
                        </div>
                    </div>
                    <div style="margin: 0 10px;" slot="reference">
                        <div class="button-plus">
                            <i
                                class="el-icon-plus"
                                style="font-size: 14px;color: #6a6c6f !important;"
                            ></i>
                            将关键词添加到文件夹
                        </div>
                    </div>
                </el-popover>
                <el-date-picker
                    v-model="filter.date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    size="mini"
                    placeholder="请选择日期"
                    style="width: 150px;margin-right: 10px"
                    @change="getList"
                    :picker-options="pickerOptions0"
                >
                </el-date-picker>
                <el-button @click="onRemarkall" type="primary" size="mini"
                    >批量备注</el-button
                >
            </div>
            <div>
                <el-button
                    v-if="KeywordSelection.length != 0"
                    @click="copyKeyword"
                    type="primary"
                    size="mini"
                    icon="el-icon-document-copy"
                    >复制选择</el-button
                >
                <el-button
                    v-if="multipleSelection.length != 0"
                    @click="deleteKeywordAll"
                    type="danger"
                    size="mini"
                    icon="el-icon-delete-solid"
                    >删除</el-button
                >
                <!-- <el-button type="success" size="mini"><i class="fas fa-table"></i> 下载</el-button> -->
                <el-button
                    size="mini"
                    icon="el-icon-refresh"
                    @click="onReset"
                ></el-button>
            </div>
        </div>
        <el-table
            v-loading="loading"
            :data="list"
            :header-cell-style="{ background: '#d1e1ff', 'font-size': '12px' }"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
            size="mini"
            style="overflow: visible;"
            ref="multipleTables"
        >
            <template slot="empty">
                <div>
                    <!-- <span>没有关键字. <span @click="add_Keywords()" class="add-keywords-link">单击此处</span> 添加此产品的关键字.</span> -->
                    <span>关键词数据未爬取数据</span>
                </div>
            </template>
            <el-table-column
                :resizable="false"
                label="#"
                sortable="custom"
                prop="index"
                width="48"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.index }}</div>
                </template>
            </el-table-column>
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column
                :resizable="false"
                :render-header="renderHeader"
                width="46"
                min-width="250"
                sortable="custom"
                prop="tag_id"
                align="center"
            >
                <template slot-scope="scope">
                    <el-popover
                        placement="right"
                        title
                        :popper-append-to-body="false"
                        :append-to-body="false"
                        popper-class="star-popper"
                        trigger="click"
                    >
                        <div style="width: 250px;">
                            <div
                                class="star-on"
                                v-for="(items, ie) in star_arr"
                                :key="ie"
                            >
                                <i
                                    @click="ontag_keyword(scope.row, items.id)"
                                    class="el-icon-star-on icon-star"
                                    style="font-size: 24px;cursor: pointer;"
                                    :style="{ color: items.color }"
                                ></i>
                                <div v-if="items.isshow && ie != 0">
                                    <el-input
                                        v-model="inpustar"
                                        size="mini"
                                        style="width: 180px;"
                                    ></el-input>
                                    <i
                                        @click="check_input(items)"
                                        class="el-icon-check check-close"
                                        style="color: #62cb31;"
                                    ></i>
                                    <i
                                        @click="close_input(items)"
                                        class="el-icon-close check-close"
                                        style="color: #a94442;"
                                    ></i>
                                </div>
                                <div
                                    v-if="!items.isshow && ie != 0"
                                    @click="triggerOnTnput(items.id)"
                                    style="cursor: pointer;"
                                >
                                    <div
                                        v-if="items.remark"
                                        style="width: 220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                                    >
                                        {{ items.remark }}
                                    </div>
                                    <span
                                        v-else
                                        style="font-size: 11px;color: #777;"
                                        >单击设置文件内容</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div slot="reference">
                            <i
                                class="el-icon-star-on icon-star"
                                @click="onReference"
                                style="font-size: 20px;cursor: pointer;"
                                :style="{ color: scope.row.tag_color }"
                            ></i>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                sortable="custom"
                label="关键词"
                prop="keyword"
                min-width="160"
            >
                <template slot-scope="scope">
                    <div style="word-break: break-word !important;">
                        {{ scope.row.keyword }}
                    </div>
                    <div style="display: flex;justify-content:space-between;">
                        <div
                            v-if="scope.row.asin != null"
                            @click="edirectToAsin(scope.row)"
                            style="cursor: pointer;color: rgb(52, 73, 94);"
                        >
                            <i
                                class="el-icon-s-promotion"
                                style="margin-right:5px;"
                            ></i
                            >{{ scope.row.asin }}
                        </div>
                        <div
                            v-if="scope.row.choice == 1"
                            class="amazon-choice-badge"
                        >
                            Amazon's <span>Choice</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                align="center"
                min-width="100"
                label="搜索趋势"
            >
                <template slot-scope="scope">
                    <div
                        v-loading="loadingkeyword_tracker"
                        :id="'keyword_tracker' + scope.row.id"
                        @click="oncharts_keyword(scope.row)"
                        class="chart spinner_div"
                    ></div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                align="center"
                sortable="custom"
                width="90"
                prop="last_show_num"
                :label="filter.date ? filter.date + '搜索量' : '最近搜索量'"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.last_show_num }}</span>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                sortable="custom"
                prop="remark"
                label="备注"
                min-width="60"
            >
                <template slot-scope="scope">
                    <div
                        v-if="
                            scope.row.remark == null || scope.row.remark == ''
                        "
                        @click="onRemark(scope.row, ' 添加备注')"
                        class="pen"
                        title="添加备注"
                    >
                        <i class="el-icon-edit"></i>
                    </div>
                    <div
                        v-else
                        @click="onRemark(scope.row, ' 编辑备注')"
                        title="编辑备注"
                        class="pen"
                    >
                        {{ scope.row.remark }}
                        <i class="el-icon-edit-outline"></i>
                    </div>
                    <!-- <div  @click="edirectToAsin(scope.row.asin)" style="cursor: pointer;color: rgb(52, 73, 94);">
                        <i class="el-icon-s-promotion" style="margin-right:5px;"></i>{{ scope.row.asin }}
                    </div> -->
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                label="竞品数量"
                sortable="custom"
                prop="competing_products"
                align="center"
                min-width="60"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.competing_products">
                        > {{ scope.row.competing_products }}
                    </div>
                    <div v-else style="color: #dc3545!important;">-</div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                label="排名"
                min-width="50"
                sortable="custom"
                prop="max_zr_rank"
                align="center"
            >
                <template slot-scope="scope">
                    <el-popover placement="top" title trigger="hover">
                        <div
                            style="width: 140px;"
                            v-if="scope.row.zr_rank.length != 0"
                        >
                            <div
                                v-for="(item, i) in scope.row.zr_rank"
                                :key="i"
                            >
                                <span>{{ Object.keys(item)[0] }}</span> :
                                <span>{{ item[Object.keys(item)[0]] }}</span>
                            </div>
                        </div>
                        <div style="width: 60px;" v-else>
                            暂无数据
                        </div>
                        <div
                            @click="oncharts(scope.row)"
                            style="cursor: pointer;"
                            slot="reference"
                        >
                            <div
                                v-if="scope.row.max_zr_rank == null"
                                style="font-size: 12px;"
                            ></div>
                            <div
                                v-else-if="scope.row.max_zr_rank == 306"
                                style="font-size: 12px;"
                            >
                                > 306
                            </div>
                            <div v-else style="font-size: 12px;">
                                {{ scope.row.max_zr_rank }}
                            </div>
                            <span
                                v-if="
                                    scope.row.zr_rank_delta == null ||
                                        scope.row.zr_rank_delta == 0
                                "
                                class="position-delta"
                                style="color: #dc3545!important;"
                                >-</span
                            >
                            <span
                                v-if="scope.row.zr_rank_delta < 0"
                                class="position-delta"
                                style="color: #dc3545!important"
                                ><i class="el-icon-top"></i>
                                {{ scope.row.zr_rank_delta * -1 }}</span
                            >
                            <span
                                v-if="scope.row.zr_rank_delta > 0"
                                class="position-delta"
                                style="color: #62cb31 !important"
                                ><i class="el-icon-bottom"></i>
                                {{ scope.row.zr_rank_delta }}</span
                            >
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                align="center"
                min-width="120"
                label="关键词趋势"
            >
                <template slot-scope="scope">
                    <div
                        v-loading="loadingWorkload"
                        :id="'workload' + scope.row.id"
                        @click="oncharts(scope.row)"
                        class="chart spinner_div"
                    ></div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                v-if="isRanking"
                align="center"
                min-width="50"
                label="相对排名"
            >
                <template slot-scope="scope">
                    <div
                        v-loading="loadingRanking"
                        @click="oncharts_rank(scope.row)"
                        style="cursor: pointer;"
                        class="spinner_div"
                    >
                        <div
                            v-if="scope.row.rank_relative == null"
                            style="font-size: 12px;"
                        >
                            -
                        </div>
                        <div v-else style="font-size: 12px;">
                            {{ scope.row.rank_relative }}/{{
                                data.competitors.length + 1
                            }}
                        </div>
                        <span
                            v-if="
                                scope.row.rank_relative_delta == null ||
                                    scope.row.rank_relative_delta == 0
                            "
                            class="position-delta"
                            style="color: #dc3545!important;"
                            >-</span
                        >
                        <span
                            v-else-if="scope.row.rank_relative_delta > 0"
                            class="position-delta"
                            style="color: #62cb31 !important;"
                            ><i class="el-icon-bottom"></i>
                            {{ scope.row.rank_relative_delta }}</span
                        >
                        <span
                            v-else-if="scope.row.rank_relative_delta < 0"
                            class="position-delta"
                            style="color: #dc3545 !important;"
                            ><i class="el-icon-top"></i>
                            {{ scope.row.rank_relative_delta * -1 }}</span
                        >
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                v-if="isRanking"
                align="center"
                min-width="60"
                label="排名平均值"
            >
                <template slot-scope="scope">
                    <div
                        v-loading="loadingRanking"
                        @click="oncharts(scope.row)"
                        style="cursor: pointer;"
                        class="spinner_div"
                    >
                        <div
                            v-if="scope.row.rank_avg == null"
                            style="font-size: 12px;"
                        >
                            -
                        </div>
                        <div v-else style="font-size: 12px;">
                            {{ scope.row.rank_avg }}
                        </div>
                        <span
                            v-if="
                                scope.row.rank_avg_delta == null ||
                                    scope.row.rank_avg_delta == 0
                            "
                            class="position-delta"
                            style="color: #dc3545!important;"
                            >-</span
                        >
                        <span
                            v-else-if="scope.row.rank_avg_delta > 0"
                            class="position-delta"
                            style="color: #62cb31 !important;"
                            ><i class="el-icon-bottom"></i>
                            {{ scope.row.rank_avg_delta }}</span
                        >
                        <span
                            v-else-if="scope.row.rank_avg_delta < 0"
                            class="position-delta"
                            style="color: #dc3545 !important;"
                            ><i class="el-icon-top"></i>
                            {{ scope.row.rank_avg_delta * -1 }}</span
                        >
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                v-if="isRanking"
                align="center"
                min-width="60"
                label="参与排名的ASIN数量"
            >
                <template slot-scope="scope">
                    <div
                        v-loading="loadingRanking"
                        @click="oncharts_asin(scope.row)"
                        style="cursor: pointer;"
                        class="spinner_div"
                    >
                        <div
                            v-if="scope.row.rank_count == null"
                            style="font-size: 12px;"
                        >
                            -
                        </div>
                        <div v-else style="font-size: 12px;">
                            {{ scope.row.rank_count }}/{{
                                data.competitors.length + 1
                            }}
                        </div>
                        <span
                            v-if="
                                scope.row.rank_count_delta == null ||
                                    scope.row.rank_count_delta == 0
                            "
                            class="position-delta"
                            style="color: #dc3545!important;"
                            >-</span
                        >
                        <span
                            v-else-if="scope.row.rank_count_delta > 0"
                            class="position-delta"
                            style="color: #62cb31 !important;"
                            ><i class="el-icon-bottom"></i>
                            {{ scope.row.rank_count_delta }}</span
                        >
                        <span
                            v-else-if="scope.row.rank_count_delta < 0"
                            class="position-delta"
                            style="color: #dc3545 !important;"
                            ><i class="el-icon-top"></i>
                            {{ scope.row.rank_count_delta * -1 }}</span
                        >
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                label="广告排名"
                sortable="custom"
                prop="max_ad_rank"
                min-width="60"
                align="center"
            >
                <template slot-scope="scope">
                    <el-popover placement="top" title trigger="hover">
                        <div
                            style="width: 140px;"
                            v-if="scope.row.ad_rank.length != 0"
                        >
                            <div
                                v-for="(item, i) in scope.row.ad_rank"
                                :key="i"
                            >
                                <span>{{ Object.keys(item)[0] }}</span> :
                                <span>{{ item[Object.keys(item)[0]] }}</span>
                            </div>
                        </div>
                        <div style="width: 60px;" v-else>
                            暂无数据
                        </div>
                        <div
                            @click="oncharts_ad(scope.row)"
                            style="cursor: pointer;"
                            slot="reference"
                        >
                            <div
                                v-if="scope.row.max_ad_rank == null"
                                style="font-size: 12px;"
                            ></div>
                            <div
                                v-else-if="scope.row.max_ad_rank == 96"
                                style="font-size: 12px;"
                            >
                                > 96
                            </div>
                            <div v-else style="font-size: 12px;">
                                {{ scope.row.max_ad_rank }}
                            </div>
                            <span
                                v-if="
                                    scope.row.ad_rank_delta == null ||
                                        scope.row.ad_rank_delta == 0
                                "
                                class="position-delta"
                                style="color: #dc3545!important;"
                                >-</span
                            >
                            <span
                                v-if="scope.row.ad_rank_delta < 0"
                                class="position-delta"
                                style="color: #dc3545!important"
                                ><i class="el-icon-top"></i>
                                {{ scope.row.ad_rank_delta * -1 }}</span
                            >
                            <span
                                v-if="scope.row.ad_rank_delta > 0"
                                class="position-delta"
                                style="color: #62cb31 !important"
                                ><i class="el-icon-bottom"></i>
                                {{ scope.row.ad_rank_delta }}</span
                            >
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <!-- <el-table-column
                :resizable="false"
                label="广告页码"
                min-width="74"
                align="center">
                <template slot-scope="scope">
                    <div style="">
                        <div>
                            <span v-if="scope.row.ad_page == null || scope.row.ad_page < 0" style="font-size: 12px;margin-right: 5px;">-</span>
                            <span v-else style="font-size: 12px;margin-right: 5px;">{{scope.row.ad_page}}</span>
                            <span v-if="scope.row.ad_page_delta == null || scope.row.ad_page_delta == 0" class="position-delta" style="color: #dc3545!important;">-</span>
                            <span v-if="scope.row.ad_page_delta < 0" class="position-delta" style="color: #dc3545!important"><i class="el-icon-top"></i> {{ scope.row.ad_page_delta * -1 }}</span>
                            <span v-if="scope.row.ad_page_delta > 0" class="position-delta" style="color: #62cb31 !important"><i class="el-icon-bottom"></i> {{ scope.row.ad_page_delta }}</span>
                        </div>
                        <div>
                            <div v-if="scope.row.ad_is_top == 1" class="amazon-choice-badge" style="margin-left: 30px;background: #e47911;">TOP</div>
                        </div>
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column
                :resizable="false"
                align="center"
                width="134"
                label="更新时间(中国时区)"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.updated_at }}</span>
                </template>
            </el-table-column>
            <el-table-column width="122" label="操作">
                <template slot-scope="scope">
                    <i
                        class="el-icon-refresh fa_icon"
                        @click="KeywordUpdateByHand(scope.row.id)"
                        title="更新数据"
                    ></i>
                    <div
                        @click="oncharts(scope.row)"
                        title="显示图形"
                        class="fa_icon_ line"
                    >
                        <icon-svg :icon-class="'curve1'"></icon-svg>
                    </div>
                    <!-- <i class="fa fa-chart-line line fa_icon"></i> -->
                    <i
                        class="el-icon-delete keyworddelete fa_icon"
                        @click="deleteKeyword(scope.row.id)"
                        title="删除关键词"
                    ></i>
                    <div
                        @click="edirectToKeyword(scope.row)"
                        title="按此关键字显示亚马逊搜索结果"
                        class="fa_icon_ line"
                    >
                        <icon-svg :icon-class="'amazon'"></icon-svg>
                    </div>
                    <!-- <i class="fab fa-amazon fa_icon"></i> -->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[10, 50, 100]"
            :total="query.total"
            background
            style="margin-top: 5px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <add-folder
            :visible="ctrl.addFolderVisible"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></add-folder>
        <add-keyword
            :visible="ctrl.addKeywordVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
            @Refresher="one_getList"
        ></add-keyword>
        <charts
            ref="charts"
            :asin="chartsDataAsin"
            :visible="ctrl.chartsFolderVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_id="charts_id"
            @close-remark="closeOnRemark"
            @close-callback="closeCllback"
        ></charts>
        <charts-ad
            ref="charts_ad"
            :visible="ctrl.charts_adVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_id="charts_id"
            @close-callback="closeCllback"
        ></charts-ad>
        <charts-asin
            ref="charts_asin"
            :visible="ctrl.charts_asinVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_id="charts_id"
            @close-callback="closeCllback"
        ></charts-asin>
        <charts-rank
            ref="charts_rank"
            :visible="ctrl.charts_rankVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_id="charts_id"
            @close-callback="closeCllback"
        ></charts-rank>
        <charts-keyword
            ref="charts_keyword_"
            :visible="ctrl.charts_keywordVisible"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_id="charts_id"
            @close-callback="closeCllback"
        ></charts-keyword>
        <add-remark
            :visible="ctrl.addRemarkkVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback1"
        ></add-remark>
        <add-remarkall
            :visible="ctrl.addRemarallkkVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback1"
        ></add-remarkall>
        <on-remark
            :visible="ctrl.onRemarkVisible"
            :formData="onRemark_obj"
            @close-callback="closeCllback2"
        ></on-remark>
    </div>
</template>
<script>
import * as api from "@/api/Product/Product";
import { link_us } from "@/utils/method";
import * as Highcharts from "highcharts";
import AddFolder from "../folders/add";
import Charts from "./charts";
import AddKeyword from "./addKeyword";
import ChartsAd from "./charts_ad";
import ChartsAsin from "./charts_asin";
import ChartsRank from "./charts_rank";
import AddRemark from "./addRemark";
import OnRemark from "./onRemark";
import AddRemarkall from "./addRemarkall";
import ChartsKeyword from "./charts_keyword";
export default {
    components: {
        AddFolder,
        Charts,
        AddKeyword,
        ChartsAd,
        ChartsAsin,
        ChartsRank,
        AddRemark,
        AddRemarkall,
        OnRemark,
        ChartsKeyword
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            loading: false,
            loadingFolders: false,
            loadingRanking: false,
            loadingWorkload: false,
            loadingkeyword_tracker: false,
            isRanking: false,
            value: "",
            date_value: "",
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6;
                }
            },
            inpustar: "",
            chartsDataAsin: "",
            list: [],
            checkList: [],
            arrFolders: [],
            arrFolders_search: [],
            nameFolders: "",
            star_arr: [],
            onRemark_obj: {},
            multipleSelection: [],
            KeywordSelection: [],
            ctrl: {
                addFolderVisible: false,
                charts_adVisible: false,
                addKeywordVisible: false,
                charts_asinVisible: false,
                charts_rankVisible: false,
                addRemarkkVisible: false,
                onRemarkVisible: false,
                addRemarallkkVisible: false,
                charts_keywordVisible: false,
                chartsFolderVisible: false
            },
            query: {
                page: 1,
                limit: 10
            },
            charts_id: "0",
            charts_keyword: "",
            filter: {},
            order: {},
            requestCount: 0,
            formData: {}
        };
    },
    // watch: {
    //     list: function() {
    //         this.$nextTick(function() {
    //             for (let i = 0; i < this.list.length; i++) {
    //                 if (this.list[i].trend) {
    //                     this.workload(
    //                         "workload" + this.list[i].id,
    //                         this.list[i].trend
    //                     );
    //                 }
    //                 if (this.list[i].show_num_sum) {
    //                     this.workload_tracker(
    //                         "keyword_tracker" + this.list[i].id,
    //                         this.list[i]
    //                     );
    //                 }
    //             }
    //         });
    //     }
    // },
    methods: {
        getList() {
            let obj = this.query;
            obj.product_id = this.data.id;
            obj.filter = this.filter;
            obj.order = this.order;
            let count = this.requestCount;
            count = count + 1;
            this.requestCount = count;
            this.loading = true;
            this.loadingWorkload = true;
            this.loadingkeyword_tracker = true;
            api.keyword_page_list(obj)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        if (this.requestCount != count) {
                            this.loadingWorkload = false;
                            this.loadingkeyword_tracker = false;
                            return;
                        }
                        this.list = res.data.list;
                        this.query.page = res.data.page;
                        this.query.total = res.data.total;
                        let arr = [];
                        let arr_key = [];
                        let that = this;
                        let list = JSON.parse(JSON.stringify(that.list));
                        for (let i = 0; i < list.length; i++) {
                            arr.push(list[i].id);
                            arr_key.push(list[i].keyword);
                        }
                        if (this.data.competitors.length != 0) {
                            this.isRanking = true;
                            this.loadingRanking = true;
                            this.getRanking(this.data.id, arr, count);
                        } else {
                            this.isRanking = false;
                        }
                        if (arr.length > 0) {
                            this.getGraph(arr, count);
                        } else {
                            this.loadingWorkload = false;
                        }
                        if (arr_key.length > 0) {
                            this.trend_batch(arr_key, count);
                        } else {
                            this.loadingkeyword_tracker = false;
                        }
                    } else {
                        this.loadingWorkload = false;
                        this.loadingkeyword_tracker = false;
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.loadingWorkload = false;
                    this.loadingkeyword_tracker = false;
                });
        },
        //曲线图备注
        closeOnRemark(data) {
            this.onRemark_obj = data;
            this.ctrl.onRemarkVisible = true;
        },
        //获取关键词曲线图数据
        KeywordUpdateByHand(id) {
            this.loading = true;
            api.beginKeywordUpdateByHand({ keyword_statistics_id: id })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.$message({
                            message: res.data,
                            type: "success"
                        });
                        this.getList();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //获取关键词曲线图数据
        async trend_batch(arr, count) {
            let that = this;
            if (that.requestCount != count) {
                return (that.loadingkeyword_tracker = false);
            }
            await api
                .search_trend_batch({
                    keywords: arr,
                    country_code: this.data.country_code
                })
                .then(res => {
                    that.loadingkeyword_tracker = false;
                    if (that.requestCount != count) return;
                    let list = JSON.parse(JSON.stringify(that.list));
                    if (res.code === 0) {
                        let data = res.data;
                        for (let i = 0; i < list.length; i++) {
                            list[i].show_num_sum_date =
                                data[list[i].keyword].date;
                            list[i].show_num_sum =
                                data[list[i].keyword].show_num_sum;
                        }
                        that.list = list;
                        for (let i = 0; i < that.list.length; i++) {
                            if (that.list[i].show_num_sum) {
                                that.workload_tracker(
                                    "keyword_tracker" + that.list[i].id,
                                    that.list[i]
                                );
                            }
                        }
                    } else {
                        that.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    that.loadingkeyword_tracker = false;
                });
        },
        //获取曲线图数据
        async getRanking(id, arr, count) {
            let that = this;
            if (that.requestCount != count) {
                return (that.loadingRanking = false);
            }
            await api
                .competitors_ranking({ product_id: id, keyword_ids: arr })
                .then(res => {
                    that.loadingRanking = false;
                    if (that.requestCount != count) return;
                    let list = JSON.parse(JSON.stringify(that.list));
                    if (res.code === 0) {
                        let data = res.data;
                        for (let i = 0; i < list.length; i++) {
                            list[i].rank_avg = data[list[i].id].rank_avg;
                            list[i].rank_count = data[list[i].id].rank_count;
                            list[i].rank_relative =
                                data[list[i].id].rank_relative;
                            list[i].rank_avg_delta =
                                data[list[i].id].rank_avg_delta;
                            list[i].rank_count_delta =
                                data[list[i].id].rank_count_delta;
                            list[i].rank_relative_delta =
                                data[list[i].id].rank_relative_delta;
                        }
                        that.list = list;
                    } else {
                        that.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.loadingRanking = false;
                });
        },
        handleSortChange(val) {
            let obj = {};
            if (val.order == "ascending") {
                obj.desc = 0;
                obj.field = val.prop;
            } else if (val.order == "descending") {
                obj.desc = 1;
                obj.field = val.prop;
            }
            this.order = obj;
            this.getList();
        },
        //筛选星级
        groupChange(data) {
            let arr = [];
            data.map(v => {
                arr.push(v.id);
            });
            this.filter.tags = arr;
            this.getList();
        },
        // 添加关键词
        add_Keywords() {
            this.formData = this.data;
            this.ctrl.dialogTitle = this.data.asin + " 添加关键词";
            this.ctrl.addKeywordVisible = true;
        },
        // 添加备注
        onRemark(data, str) {
            this.formData = JSON.parse(JSON.stringify(data));
            this.ctrl.dialogTitle = data.keyword + str;
            this.ctrl.addRemarkkVisible = true;
        },
        // 批量添加备注
        onRemarkall() {
            let obj = {};
            obj.product_id = this.data.id;
            this.formData = obj;
            this.ctrl.dialogTitle = "批量备注";
            this.ctrl.addRemarallkkVisible = true;
        },
        //获取曲线图数据
        async getGraph(arr, count) {
            let that = this;
            if (that.requestCount != count) {
                return (that.loadingWorkload = false);
            }
            await api
                .trend_batch({ keyword_ids: arr })
                .then(res => {
                    that.loadingWorkload = false;
                    if (that.requestCount != count) return;
                    let list = JSON.parse(JSON.stringify(that.list));
                    if (res.code === 0) {
                        let data = res.data;
                        for (let i = 0; i < list.length; i++) {
                            list[i].trend = data[list[i].id];
                        }
                        that.list = list;
                        for (let i = 0; i < that.list.length; i++) {
                            if (that.list[i].trend) {
                                that.workload(
                                    "workload" + that.list[i].id,
                                    that.list[i].trend
                                );
                            }
                        }
                    } else {
                        that.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    that.loadingWorkload = false;
                });
        },
        renderHeader(h) {
            return h("span", [
                h("i", {
                    class: "el-icon-star-on",
                    style:
                        "color: #555;font-size: 20px;transform: translateY(3px)"
                })
            ]);
        },
        onReference() {
            this.star_arr = JSON.parse(
                JSON.stringify(this.$store.state.admin.star_arr)
            );
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            let url =
                link_us(this.data.country_code) +
                "dp/" +
                data.asin +
                "?th=1&psc=1";
            window.open(url, "_blank");
        },
        //跳转到亚马逊关键词页面
        edirectToKeyword(data) {
            let str = data.keyword.replace(/[\s]+/g, "+");
            let url = link_us(this.data.country_code) + "s?k=" + str;
            window.open(url, "_blank");
        },
        //获取文件列表
        clickFolders() {
            this.loadingFolders = true;
            api.kw_folder_all()
                .then(res => {
                    this.loadingFolders = false;
                    if (res.code === 0) {
                        this.arrFolders = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loadingFolders = false;
                });
        },
        //打开曲线图
        oncharts(data) {
            let that = this;
            this.charts_id = data.id;
            this.charts_keyword = data.keyword;
            this.formData = this.data;
            this.ctrl.dialogTitle = `${this.data.asin} : ${data.keyword}`;
            if (data.asin) {
                this.chartsDataAsin = data.asin;
            } else {
                this.chartsDataAsin = this.data.asin;
            }
            this.ctrl.chartsFolderVisible = true;
            setTimeout(function() {
                that.$refs.charts.getList(data.id, 30);
            }, 100);
        },
        //打开关键词曲线图
        oncharts_keyword(data) {
            let that = this;
            this.charts_id = data.id;
            this.charts_keyword = data.keyword;
            this.ctrl.dialogTitle = `${data.keyword} 的搜索趋势图`;
            this.ctrl.charts_keywordVisible = true;
            setTimeout(function() {
                that.$refs.charts_keyword_.getList(
                    data.keyword,
                    null,
                    that.data.country_code
                );
            }, 100);
        },
        //打开曲线图广告
        oncharts_ad(data) {
            // if (data.ad_rank == -1) {
            //     return this.$alert(
            //         "在指定的时间范围内没有可用的数据.",
            //         "提示",
            //         {
            //             confirmButtonText: "确定"
            //         }
            //     );
            // }
            let that = this;
            this.charts_id = data.id;
            this.charts_keyword = data.keyword;
            this.formData = this.data;
            this.ctrl.dialogTitle = `${this.data.asin} : ${data.keyword} (广告排名)`;
            this.ctrl.charts_adVisible = true;
            setTimeout(function() {
                that.$refs.charts_ad.getList(data.id, 30);
            }, 100);
        },
        //打开曲线图广告(asin)
        oncharts_rank(data) {
            let that = this;
            this.charts_id = data.id;
            this.charts_keyword = data.keyword;
            this.formData = this.data;
            this.ctrl.dialogTitle = `${this.data.asin} : ${data.keyword} (相对于竞争对手的排名)`;
            this.ctrl.charts_rankVisible = true;
            setTimeout(function() {
                that.$refs.charts_rank.getList(data.id, 30);
            }, 100);
        },
        //打开曲线图广告(rank)
        oncharts_asin(data) {
            let that = this;
            this.charts_id = data.id;
            this.charts_keyword = data.keyword;
            this.formData = this.data;
            this.ctrl.dialogTitle = `${this.data.asin} : ${data.keyword} (有排名的ASIN数量)`;
            this.ctrl.charts_asinVisible = true;
            setTimeout(function() {
                that.$refs.charts_asin.getList(data.id, 30);
            }, 100);
        },
        //把关键词添加到文件夹
        keywordFolders(data) {
            if (this.KeywordSelection.length == 0) {
                return this.$message({
                    message: "必须至少选择一个关键字",
                    type: "error"
                });
            }
            this.loadingFolders = true;
            api.put_keyword({
                id: data.id,
                keywords: this.KeywordSelection
            })
                .then(res => {
                    this.loadingFolders = false;
                    if (res.code === 0) {
                        this.$message({
                            message: `关键字已成功添加到“${data.name}”文件夹`,
                            type: "success"
                        });
                        this.clickFolders();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loadingFolders = false;
                });
        },
        //文件夹搜索
        inputFolders(val) {
            let arr = JSON.parse(JSON.stringify(this.arrFolders));
            let searcharr = [];
            arr.forEach(item => {
                if (item.name.indexOf(val.toLowerCase()) != -1) {
                    searcharr.push(item);
                }
            });
            this.arrFolders_search = searcharr;
        },
        //添加文件夹
        addFolders() {
            this.ctrl.dialogTitle = "创建新文件夹";
            this.ctrl.addFolderVisible = true;
        },
        // 数组按换行符拼接成字符串
        arr_str(arr) {
            let str = "";
            if (arr.length != 0) {
                for (let i = 0; i < arr.length; i++) {
                    str += arr[i] + "\n";
                }
            }
            return str;
        },
        //复制关键词
        copyKeyword() {
            const input = document.createElement("textarea");
            input.value = this.arr_str(this.KeywordSelection);
            document.body.appendChild(input);
            input.select();
            document.execCommand("Copy");
            document.body.removeChild(input);
        },
        //删除关键词
        deleteKeywordAll() {
            if (this.KeywordSelection.length == 0) {
                return this.$message({
                    message: "必须至少选择一个关键字",
                    type: "error"
                });
            }
            this.$confirm(
                `确定要删除这 ${this.multipleSelection.length} 个关键词吗?`,
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            )
                .then(() => {
                    this.loading = true;
                    api.remark_remove({
                        ids: this.multipleSelection
                    })
                        .then(res => {
                            this.loading = false;
                            if (res.code === 0) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.$emit(
                                    "close-list",
                                    this.data,
                                    this.query.total -
                                        this.multipleSelection.length
                                );
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {});
        },
        deleteKeyword(id) {
            this.$confirm(
                `删除关键字也将删除其所有历史记录。此操作无法撤消。确定要继续吗？`,
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            )
                .then(() => {
                    this.loading = true;
                    api.remark_remove({
                        ids: [id]
                    })
                        .then(res => {
                            this.loading = false;
                            if (res.code === 0) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.$emit(
                                    "close-list",
                                    this.data,
                                    this.query.total - 1
                                );
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {});
        },
        //搜索
        oninput(val) {
            let that = this;
            clearTimeout(this.timeout);
            that.timeout = setTimeout(() => {
                that.query.page = 1;
                that.filter.keyword = val;
                that.getList();
            }, 800);
        },
        //触发input
        triggerOnTnput(id) {
            for (let i = 0; i < this.star_arr.length; i++) {
                if (this.star_arr[i].id == id) {
                    this.inpustar = "";
                    this.star_arr[i].isshow = true;
                } else {
                    this.star_arr[i].isshow = false;
                }
            }
        },
        //取消input
        close_input(items) {
            items.isshow = false;
            this.inpustar = "";
        },
        //文本确定
        check_input(items) {
            this.loading = false;
            api.remark_tag({
                tag_id: items.id,
                remark: this.inpustar
            })
                .then(res => {
                    if (res.code === 0) {
                        api.keyword_tags().then(res => {
                            if (res.code === 0) {
                                let arr = res.data;
                                for (let i = 0; i < arr.length; i++) {
                                    arr[i].isshow = false;
                                }
                                this.$store.commit("changeTarBar", arr);
                                this.star_arr = JSON.parse(JSON.stringify(arr));
                            }
                            this.inpustar = "";
                            items.isshow = false;
                            this.loading = false;
                        });
                    } else {
                        this.loading = false;
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //多选框
        handleSelectionChange(val) {
            let arr = [];
            let Keyword = [];
            val.map(v => {
                arr.push(v.id);
                Keyword.push(v.keyword);
            });
            this.multipleSelection = arr;
            this.KeywordSelection = Keyword;
        },
        //刷新
        onReset() {
            this.list = [];
            this.getList();
        },
        one_getList() {
            this.getList();
        },
        //清空星星
        onEmpty() {
            this.checkList = [];
            this.filter.tags = [];
            this.getList();
        },
        //打标
        ontag_keyword(data, tag_id) {
            this.loading = true;
            api.tag_keyword({
                keyword_id: data.id,
                tag_id: tag_id
            })
                .then(res => {
                    if (res.code === 0) {
                        data.tag_id = tag_id;
                        for (let i = 0; i < this.star_arr.length; i++) {
                            if (this.star_arr[i].id == tag_id) {
                                data.tag_color = this.star_arr[i].color;
                                break;
                            }
                        }
                        this.loading = false;
                    } else {
                        this.loading = false;
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        workload(id_name, data) {
            let workload_id = document.getElementById(id_name);
            let dates = data.date;
            let datas = [];
            for (let i = 0; i < data.rank.length; i++) {
                datas.push(data.rank[i] == null || data.rank[i] == -1 ? null : data.rank[i]);
            }

            this.sparkLine(workload_id, datas, dates, 1);
        },
        workload_tracker(id_name, data) {
            let workload_id = document.getElementById(id_name);
            let datas = [];
            for (let i = 0; i < data.show_num_sum.length; i++) {
                datas.push(
                    data.show_num_sum[i] == null
                        ? null
                        : data.show_num_sum[i] * -1
                );
            }
            this.sparkLine(workload_id, datas, data.show_num_sum_date, 2);
        },
        sparkLine(div, datas, dates, index) {
            var options = {
                chart: {
                    borderWidth: 0,
                    // type: "area",
                    margin: [8, 40, 8, 10],
                    width: 100,
                    height: 36,
                    style: {
                        overflow: "visible"
                    },
                    skipClone: true
                },
                title: {
                    text: null
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    categories: dates,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: [],
                    tickWidth: 0,
                    lineColor: "#fff"
                },
                yAxis: {
                    reversed: true,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    minPadding: 0,
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: []
                },
                legend: {
                    enabled: false
                },
                exporting: { enabled: false },
                tooltip: {
                    formatter: function() {
                        if (index == 1) {
                            return `<span style="font-size: 10px;">${this.x}</span><br/><b>${this.y}</b>`;
                        }
                        if (index == 2) {
                            return `<span style="font-size: 10px;">${
                                this.x
                            }</span><br/><b>${this.y * -1}</b>`;
                        }
                    },
                    hideDelay: 0,
                    outside: true
                },
                series: [{ data: datas }],
                plotOptions: {
                    series: {
                        animation: false,
                        lineWidth: 1,
                        shadow: false,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        marker: {
                            radius: 1,
                            states: {
                                hover: {
                                    radius: 2
                                }
                            }
                        },
                        fillOpacity: 0.25
                    },
                    column: {
                        negativeColor: "#910000",
                        borderColor: "silver"
                    }
                }
            };

            return new Highcharts.Chart(div, options);
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.addFolderVisible = false;
            this.ctrl.chartsFolderVisible = false;
            this.ctrl.charts_adVisible = false;
            this.ctrl.addKeywordVisible = false;
            this.ctrl.charts_asinVisible = false;
            this.ctrl.charts_rankVisible = false;
            this.ctrl.addRemarkkVisible = false;
            this.ctrl.addRemarallkkVisible = false;
            this.ctrl.charts_keywordVisible = false;
            if (isshow) return;
        },
        // 关闭弹窗回调
        closeCllback1(isshow) {
            this.ctrl.addRemarkkVisible = false;
            this.ctrl.addRemarallkkVisible = false;
            if (isshow) return;
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback2(isshow, id) {
            this.ctrl.onRemarkVisible = false;
            if (isshow) return;
            this.$refs.charts.getList_onRemark(id);
        }
    }
};
</script>
<style type="text/scss" lang="scss">
.select-popper {
    .popper__arrow {
        display: none !important;
    }
    margin-top: 3px !important;
    padding: 5px 0 !important;
    box-sizing: border-box !important;
}
.star-popper {
    padding: 3px 5px !important;
    .el-input__inner {
        height: 24px !important;
        line-height: 24px !important;
        padding: 0 8px !important;
    }
}
</style>
<style type="text/scss" lang="scss" scoped>
.amazon-choice-badge {
    background-color: #222;
    color: #fff;
    padding: 2px 5px;
    display: inline-block;
    font-size: 10px !important;
    box-sizing: border-box;
    transform: scale(0.65);
    position: relative;
    right: 16px;
    span {
        color: #e47911;
    }
}
.pen {
    cursor: pointer;
}
.pen:hover {
    text-decoration: underline;
}
.add-keywords-link {
    cursor: pointer;
    text-decoration: underline;
    color: #34495e;
    display: inline;
}
.add-keywords-link:hover {
    text-decoration: none;
    color: #23527c;
}
.fa_icon {
    font-size: 16px;
    cursor: pointer;
    margin-right: 10px;
}
.fa_icon_ {
    font-size: 18px;
    cursor: pointer;
    margin-right: 10px;
    color: #606266;
}
.keyworddelete:hover {
    color: red;
}
.line {
    display: inline-block;
}
.dropdown-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    color: #003873;
    line-height: 1.2;
    margin: 0;
    padding: 6px 8px 6px 11px;
    cursor: default;
    user-select: none;
}
.dropdown-header__title {
    font-size: 14px;
    font-weight: 600;
    color: #8c8c8c;
}
.dropdown-items {
    overflow-y: auto;
    min-height: 0;
    max-height: 276px;
    transition: height 400ms cubic-bezier(0.5, 0, 0.2, 1);
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #fff !important;
}
/deep/ .el-table__body-wrapper {
    overflow: visible !important;
}

/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
.dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 6px 6px 11px;
    font-size: 14px;
    font-weight: 400;
    color: #343a40;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    box-sizing: border-box;
    .dropdown-item-txt {
        width: 132px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    span {
        padding-right: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }
}
.dropdown-item:hover {
    background: rgb(240, 240, 240);
}
.no_folders {
    padding: 0 15px;
    font-size: 12px;
    color: #a5a8aa;
}
.folder {
    color: #003873;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 6px 6px 11px;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
}
.folder:hover {
    background: rgb(240, 240, 240);
}
.check-close {
    font-size: 18px;
    cursor: pointer;
    position: relative;
    top: 2px;
    margin-left: 3px;
    font-weight: 900;
}
.star-on {
    display: flex;
    margin: 5px 0;
    align-items: center;
}
/deep/ .el-table td,
.el-table th.is-leaf {
    border-right: none;
}
.empty {
    padding: 3px 10px;
    font-weight: 400;
    color: #212529;
    font-size: 12px;
    cursor: pointer;
}
.empty:hover {
    background: rgb(240, 240, 240);
}
.icon-star {
    position: relative;
    top: -2px;
}
.checkbox-div {
    /deep/ .el-checkbox {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 2.5px 10px;
    }
    /deep/ .el-checkbox:hover {
        background: rgb(240, 240, 240);
    }
    /deep/ .el-checkbox__label {
        padding-left: 5px !important;
        margin-right: 5px !important;
        display: flex;
        align-items: center;
    }
}
/deep/ .button-star {
    .el-button {
        padding: 4.2px 5.5px;
    }
    .el-button:hover {
        background: #fff !important;
    }
}
/deep/ .el-divider--horizontal {
    margin: 8px 0 4px 0 !important;
}
.button-plus {
    cursor: pointer;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
    padding: 0 5.5px;
    background: #fff;
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    color: #606266;
    font-weight: 500;
    border-radius: 4px;
}
.caret-bottom {
    position: relative;
    top: -3px;
    margin-left: 3px;
}
/deep/ .highcharts-credits {
    display: none !important;
}
.chart {
    position: relative;
    overflow: visible;
    width: 100px;
    height: 36px;
    z-index: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.spinner_div {
    /deep/ .el-loading-spinner {
        transform: translateY(10px);
        .circular {
            height: 20px !important;
            width: 20px !important;
        }
    }
}
.filter-block {
    background-color: #a9c7ff;
    padding: 6px 6px 6px 10px;
    font-size: 18px;
    color: #333;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.filter-block-left {
    display: flex;
    align-items: center;
}
/deep/ .el-table--border {
    border: none;
}
</style>
